












import { defineComponent } from "@vue/composition-api";
import { isMobile } from "@/lib/browserUtils";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AudioRecordingView",
  components: { BaseIcon },
  props: {
    recording: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const onStopRecord = () => {
      emit(`stopRecord`);
    };
    const onStartRecord = (e?: TouchEvent) => {
      e?.preventDefault();
      emit("startRecord");
    };

    const onToggleRecord = () => {
      if (isMobile()) return;
      if (props.recording) {
        onStopRecord();
      } else {
        onStartRecord();
      }
    };

    return { onToggleRecord, onStartRecord, onStopRecord };
  },
});
